module.exports = __webpack_public_path__ + "img/Journalisma8.69f1036a.png";